/* =========================================================================
   Alama Studio · Landing «For Interior Designers» v2
   Comportamenti nuovi: passaggio del logo, errori leggibili, messaggio
   d'invio fallito in vista, evento email, focus a menu aperto e dopo Esc,
   reti di sicurezza. Il form e' la sezione alama-v2-form (section#contact,
   form #v2-lead-form), sempre in pagina: nessun pannello (decisioni di
   Matteo del 2026-10-03 e 2026-10-05).
   Caricato con defer DOPO alama-trade-v3.js (header, menu, reveal,
   tracciamento: invariato) e alama-v2-form.js (validazione e invio al CRM
   del form): qui l'invio non si tocca. Ogni modulo gira nel suo try/catch.
   Nessuna dipendenza.
   ========================================================================= */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var toggle = doc.getElementById('nav-toggle');

  /* -----------------------------------------------------------------------
     Utilita'
     ----------------------------------------------------------------------- */
  // Come track() di v3: dataLayer e gtag se presenti, mai un errore in pagina.
  function track(eventName, params) {
    params = params || {};
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: eventName }, params));
      }
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
      }
    } catch (e) { /* il tracciamento non rompe mai la pagina */ }
  }

  // Come locationOf() di v3, con le sole voci possibili per un'email.
  function locationOf(el) {
    if (el.closest('.site-header')) return 'header';
    if (el.closest('.site-footer')) return 'footer';
    if (el.closest('#contact')) return 'final';
    return 'page';
  }

  function closestTo(e, selector) {
    var t = e.target;
    return t && t.closest ? t.closest(selector) : null;
  }

  function revealAll(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('.reveal'), function (el) {
      el.classList.add('is-in');
    });
  }

  // change di matchMedia; addListener per Safari < 14.
  function onMedia(mq, fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }

  // true solo se il focus e' arrivato (elemento visibile, non inert).
  function tryFocus(el, opts) {
    if (!el || typeof el.focus !== 'function' || !doc.contains(el)) return false;
    el.focus(opts);
    return doc.activeElement === el;
  }

  function menuIsOpen() {
    return !!toggle && toggle.getAttribute('aria-expanded') === 'true';
  }

  /* -----------------------------------------------------------------------
     8 · Rete sull'invio (registrata per prima, anche nell'editor)
     Il listener di alama-v2-form.js sta sul form e scatta prima di questo,
     che sta su document. Se nessuno ha bloccato l'invio (script del form
     assente o rotto) lo blocca e mostra il .form-status col mailto: l'invio
     nativo andrebbe in GET sulla stessa URL, il lead si perderebbe e i dati
     finirebbero nella query string letta dal PageView del Pixel.
     ----------------------------------------------------------------------- */
  function initSubmitNet() {
    doc.addEventListener('submit', function (e) {
      var form = e.target;
      if (e.defaultPrevented || !form || !form.classList || !form.classList.contains('lead-form')) return;
      e.preventDefault();
      var status = form.querySelector('.form-status');
      if (status) status.classList.add('is-visible');
    });
  }

  /* -----------------------------------------------------------------------
     5 · Errori leggibili
     Lo script del form scrive aria-invalid sui campi: un campo non valido riceve
     aria-describedby="<id>-error" (il suo p.field-error), uno tornato valido
     lo perde. Altri id gia' presenti restano.
     ----------------------------------------------------------------------- */
  var errorObserver = null;

  function describeError(field) {
    var errId = field.id ? field.id + '-error' : '';
    if (!errId || !doc.getElementById(errId)) return;
    var ids = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    var at = ids.indexOf(errId);
    var invalid = field.getAttribute('aria-invalid') === 'true';
    if (invalid && at < 0) ids.push(errId);
    if (!invalid && at > -1) ids.splice(at, 1);
    if (ids.length) field.setAttribute('aria-describedby', ids.join(' '));
    else field.removeAttribute('aria-describedby');
  }

  function watchErrors() {
    if (errorObserver) { errorObserver.disconnect(); errorObserver = null; }
    var form = doc.querySelector('form.lead-form');
    if (!form || !('MutationObserver' in window)) return;
    errorObserver = new MutationObserver(function (records) {
      records.forEach(function (r) { describeError(r.target); });
    });
    errorObserver.observe(form, { subtree: true, attributes: true, attributeFilter: ['aria-invalid'] });
  }

  /* -----------------------------------------------------------------------
     5b · Messaggio d'invio fallito in vista
     Se il ponte CRM risponde con un errore (rete, CRM fermo, telefono che il
     CRM rifiuta), lo script del form riporta il bottone a «Request information» e accende
     #form-error (.is-visible) sotto il bottone, a volte fuori vista (sul
     telefono). La rete sull'invio (punto 8) accende la stessa classe. A ogni
     mutazione che la lascia accesa il messaggio scorre in vista con 'nearest'
     (gia' in vista: nulla si muove), rispettando lo scroll-behavior del CSS. Il focus non si sposta: role="alert" fa gia'
     l'annuncio e il bottone resta pronto per riprovare.
     ----------------------------------------------------------------------- */
  var statusObserver = null;

  function watchStatus() {
    if (statusObserver) { statusObserver.disconnect(); statusObserver = null; }
    var status = doc.getElementById('form-error');
    if (!status || !('MutationObserver' in window)) return;
    statusObserver = new MutationObserver(function () {
      if (!status.classList.contains('is-visible')) return;
      status.scrollIntoView({ block: 'nearest' });
    });
    statusObserver.observe(status, { attributes: true, attributeFilter: ['class'] });
  }

  /* -----------------------------------------------------------------------
     1 · Editor del tema (Shopify.designMode)
     Logo dell'header visibile. v3 osserva i .reveal solo
     al caricamento: una sezione rigenerata resterebbe a opacita' 0.
     ----------------------------------------------------------------------- */
  function initEditor() {
    root.classList.remove('v2-handoff'); // il layout non la mette in design_mode
    revealAll(doc);
    doc.addEventListener('shopify:section:load', function (e) {
      var section = e.target;
      if (!section || !section.querySelector) return;
      revealAll(section);
      if (!section.querySelector('form.lead-form')) return;
      // form rigenerato: i due osservatori si riagganciano ai nodi nuovi
      try { watchErrors(); } catch (e1) { /* errori senza descrizione */ }
      try { watchStatus(); } catch (e2) { /* messaggio d'errore senza scorrimento */ }
    });
  }

  /* -----------------------------------------------------------------------
     6 · Evento email_click
     Sui mailto con data-v2-track="email" (colofone e footer). Un
     mailto non arriva al CRM: non ha data-cta e non tocca info_request_click.
     ----------------------------------------------------------------------- */
  function initEmailTracking() {
    doc.addEventListener('click', function (e) {
      var link = closestTo(e, '[data-v2-track="email"]');
      if (link) track('email_click', { location: locationOf(link) });
    });
  }

  /* -----------------------------------------------------------------------
     Rete sul reveal
     Se v3 non arriva o si ferma prima del suo observer, i .reveal
     resterebbero a opacita' 0. Stesse opzioni di v3: con v3 attivo non
     cambia nulla. Senza IntersectionObserver, tutto visibile subito.
     ----------------------------------------------------------------------- */
  function initRevealNet() {
    var reveals = doc.querySelectorAll('.reveal');
    if (!reveals.length) return;
    if (!('IntersectionObserver' in window)) { revealAll(doc); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(reveals, function (el) {
      if (!el.classList.contains('is-in')) io.observe(el);
    });
  }

  /* -----------------------------------------------------------------------
     7 · Focus a menu aperto
     Il menu copre la pagina: con aria-expanded="true" su #nav-toggle (lo
     scrive v3) #main, .site-footer e .skip-link diventano inert, con "false"
     tornano attivi. Mai su header e menu: la X resta raggiungibile. Si
     tolgono solo gli inert messi qui.
     ----------------------------------------------------------------------- */
  var menuInert = [];

  function syncMenuInert() {
    var open = menuIsOpen();
    if (open && !menuInert.length) {
      [doc.getElementById('main'), doc.querySelector('.site-footer'), doc.querySelector('.skip-link')].forEach(function (el) {
        if (el && !el.hasAttribute('inert')) { el.setAttribute('inert', ''); menuInert.push(el); }
      });
    } else if (!open && menuInert.length) {
      menuInert.forEach(function (el) { el.removeAttribute('inert'); });
      menuInert = [];
    }
  }

  function initMenuFocus() {
    if (!toggle || !('MutationObserver' in window)) return;
    new MutationObserver(syncMenuInert).observe(toggle, { attributes: true, attributeFilter: ['aria-expanded'] });
    syncMenuInert(); // menu gia' aperto prima che arrivasse questo file
  }

  /* -----------------------------------------------------------------------
     7b · Esc nel menu
     v3 chiude il menu con Escape (il suo listener e' registrato prima di
     questo e scatta prima), ma il focus resterebbe su una voce che sta per
     nascondersi, o tornerebbe a body, e il Tab successivo ripartirebbe da
     #main saltando l'header. Qui torna all'hamburger. Solo Esc: chiudendo il menu con un link il focus resta
     all'ancora. Se v3 non ha chiuso il menu (tasto «Esc» dei browser vecchi),
     il focus non si sposta.
     ----------------------------------------------------------------------- */
  function initMenuEscape() {
    var drawer = doc.getElementById('mobile-nav');
    if (!toggle || !drawer) return;
    doc.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (menuIsOpen() || !drawer.contains(doc.activeElement)) return;
      tryFocus(toggle);
    });
  }

  /* -----------------------------------------------------------------------
     Menu aperto e viewport che passa sopra 1100 px (iPad che ruota): il
     toggle sparisce e il menu resterebbe aperto. Lo chiude il click di v3,
     che rimette anche l'overflow del body; gli inert li toglie il punto 7.
     ----------------------------------------------------------------------- */
  function initMenuWide() {
    if (!toggle || !window.matchMedia) return;
    var wide = window.matchMedia('(min-width: 1100px)');
    onMedia(wide, function () {
      if (wide.matches && menuIsOpen()) toggle.click();
    });
  }

  /* -----------------------------------------------------------------------
     2 · Passaggio del logo
     html.v2-handoff la mette lo script inline del layout, prima del primo
     paint. Si decide sulla geometria (top del logotipo contro --header-h),
     una misura per frame di scroll o resize: niente IntersectionObserver a
     soglia, che con zoom e scale frazionarie puo' restare a 0,99.
     ----------------------------------------------------------------------- */
  function initHandoff() {
    if (!root.classList.contains('v2-handoff')) return;
    var logo = doc.querySelector('.v2-hero__logotype');
    var brand = doc.querySelector('.site-header .brand');
    var header = brand ? brand.closest('.site-header') : null;
    if (!logo || !brand || !header) { root.classList.remove('v2-handoff'); return; }

    // Rete del CSS gia' scattata (6 s senza v2-live): un marchio gia' mostrato
    // non si rinasconde. A menu aperto il logo e' visibile per regola CSS e la
    // lettura non dice nulla: decide il tempo trascorso.
    var shown = menuIsOpen()
      ? (!window.performance || performance.now() >= 6000)
      : getComputedStyle(brand).visibility === 'visible';
    if (shown) { root.classList.remove('v2-handoff'); return; }

    var headerH = 76;
    var readH = true;
    var under = null;
    var queued = false;

    function update() {
      queued = false;
      if (readH) {
        readH = false;
        var h = parseFloat(getComputedStyle(root).getPropertyValue('--header-h'));
        headerH = h > 0 ? h : 76;
      }
      var now = logo.getBoundingClientRect().top < headerH - 0.5;
      if (now === under) return; // classi scritte solo al cambio di stato
      under = now;
      root.classList.toggle('v2-brand-on', now);
      header.classList.toggle('v2-solid', now);
    }

    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', function () { readH = true; queue(); });
    update();
    // Solo ora: se qualcosa qui sopra fallisce, dopo 6 s la rete del CSS mostra il logo.
    root.classList.add('v2-live');
  }

  /* -----------------------------------------------------------------------
     Avvio
     Rete sull'invio per prima, anche nell'editor.
     ----------------------------------------------------------------------- */
  try { initSubmitNet(); } catch (e) { /* resta l'invio di v3 */ }

  var designMode = false;
  try { designMode = !!(window.Shopify && window.Shopify.designMode); } catch (e) { /* fuori dall'editor */ }

  if (designMode) {
    try { initEditor(); } catch (e) { /* editor senza aiuti */ }
    try { watchErrors(); } catch (e) { /* errori senza descrizione */ }
    try { watchStatus(); } catch (e) { /* messaggio d'errore senza scorrimento */ }
    return;
  }

  try { watchErrors(); } catch (e) { /* errori senza descrizione */ }
  try { watchStatus(); } catch (e) { /* messaggio d'errore senza scorrimento */ }
  try { initEmailTracking(); } catch (e) { /* niente email_click */ }
  try { initRevealNet(); } catch (e) { try { revealAll(doc); } catch (e2) { /* niente */ } }
  try { initMenuFocus(); } catch (e) { /* menu senza inert */ }
  try { initMenuEscape(); } catch (e) { /* Esc nel menu senza ritorno del focus */ }
  try { initMenuWide(); } catch (e) { /* menu non chiuso oltre 1100 px */ }
  try { initHandoff(); } catch (e) { /* dopo 6 s la rete del CSS mostra il logo */ }
})();
